<template>
  
  <div class="container mt-4">
    <h2 class="section-title mb-2 h1">BERITA</h2>
    <p class="text-center text-muted h5">MUI</p>
    <br/>
    <div v-for="news in newsList" :key="news.id" class="row mb-3 border-bottom pb-3">
      <!-- Kolom Gambar -->
      <div class="col-md-3">
        <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${news.image}`" alt="news image" class="img-fluid rounded">
      </div>
      <!-- Kolom Informasi -->
      <div class="col-md-9">
        <h5>
          <router-link :to="`/berita/${news.id}`" class="text-decoration-none text-primary"
                  ><h2>{{ news.judul }}</h2></router-link
                >
        </h5>
        <div v-html="sanitize(news.isi)"></div>
        <small class="text-muted">{{ formatDate(news.create_at) }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import DOMPurify from 'dompurify';

export default {
  data() {
    return {
      newsList: [],
      loading: true,
      error: null,
    };
  },
 
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get(
          "https://mui-kendal.or.id/pengurus/api/AllNews"
        );
        this.newsList = response.data;
        console.log(this.newsList)
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    sanitize(html) {
      return DOMPurify.sanitize(html);
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
  },
};

</script>

<style scoped>
.section-title {
  text-align: center;
  color: #007b5e;
  margin-bottom: 50px;
  text-transform: uppercase;
}
.news-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.news-item {
  border: 1px solid #ddd;
  padding: 1rem;
  border-radius: 8px;
}
.news-image {
  width: 10%;
  height: auto;
  border-radius: 8px;
}
</style>
